import React from "react";
import { Modal } from "react-bootstrap";

const CdxModal = (props) => {

    const noGlow = props.noGlow ? " no-glow " : "";
    return (
        <Modal
            scrollable={true}
            {...props}
            centered
            className={props.className ? "cdx-modal " + props.className + noGlow : "cdx-modal " + noGlow}
        >
            <div className={props.noBorder ? "modal-content-wrapper no-border" : "modal-content-wrapper"}>
                {props.children}
            </div>
        </Modal>
    );
};

const Header = (props) => {
    const { children, onClose } = props;
    const noBorder = props.noBorder ? "no-border" : "";
    return (
        <Modal.Header
            {...props}
            className={props.className ? "cdx-modal-header " + props.className + ' ' + noBorder : "cdx-modal-header " + noBorder}
        >
            {children}
            {onClose && <div className="cdx-modal-close" onClick={onClose} />}
        </Modal.Header>
    );
};

const Body = (props) => {
    const { children } = props;
    return (
        <Modal.Body
            {...props}
            className={props.className ? "cdx-modal-body " + props.className : "cdx-modal-body"}
        >
            {children}
        </Modal.Body>
    );
};

const Footer = (props) => {
    const { children } = props;
    return (
        <Modal.Footer
            {...props}
            className={props.className ? "cdx-modal-footer " + props.className : "cdx-modal-footer"}
        >
            {children}
        </Modal.Footer>
    );
};

CdxModal.Header = Header;
CdxModal.Body = Body;
CdxModal.Footer = Footer;

export default CdxModal;

